import React from 'react';
import { motion } from 'framer-motion';

const Process = () => {
  const steps = [
    {
      num: "1",
      title: "Request Audit",
      desc: "Fill out the short form below. It takes less than 2 minutes."
    },
    {
      num: "2",
      title: "We Analyze",
      desc: "We manually review your visibility, competitors, Google profile, and website."
    },
    {
      num: "3",
      title: "Get Your Report",
      desc: "Within 48 hours, receive your custom PDF scorecard and action plan."
    },
    {
      num: "4",
      title: "Dominate",
      desc: "Implement the fixes (or hire us to do it) and watch your leads grow."
    }
  ];

  return (
    <section id="process" className="py-24 relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-6">How It Works</h2>
          <p className="text-xl text-slate-400">A simple, transparent process to uncover your growth gaps.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="relative"
            >
              <div className="glass-card rounded-2xl p-8 h-full relative z-10 hover:-translate-y-2 transition-transform duration-300">
                <div className="w-14 h-14 bg-teal text-navy rounded-full flex items-center justify-center text-2xl font-black mb-6 shadow-[0_0_15px_rgba(0,212,200,0.5)]">
                  {step.num}
                </div>
                <h3 className="text-2xl font-bold text-white mb-3">{step.title}</h3>
                <p className="text-slate-400 leading-relaxed">
                  {step.desc}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;